/* esm.sh - @smithy/util-base64@4.4.3 */
export * from "/*@smithy/util-base64@4.4.3/esnext/util-base64.mjs";
